const config = {
    BASE_URL: process.env.NODE_ENV === 'production'
      ? 'http://themis.msh-lse.fr:3080'
      : 'http://localhost:3080',
  };
  
  export default config;